import PrescreeningSettingsContainer from "./PrescreeningSettingsContainer";

export default PrescreeningSettingsContainer;
